import makeStyles from '@mui/styles/makeStyles';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100%',
  },
  header: {
    marginBottom: isMobile ? 35 : 70,
    padding: isMobile ? 5 : undefined,
    paddingRight: isMobile ? 30 : undefined,
    lineHeight: isMobile ? 1.5 : undefined,
  },
  form: {
    maxWidth: '25rem',
    width: '100%',
  },
  textField: {
    minHeight: 88,
    width: '100%',
  },

  text: {
    textAlign: 'center',
    '& a': {
      color: 'white',
    },
  },
  alert: {
    marginBottom: theme.spacing(3),
  },
}));

export default useStyles;
